import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web--source/common/localization/getCountryDisplayNameFromSessionCountry";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
// We wish to access this value in other places
export var getDefaultTitle = function(strictLocalize) {
    var countryDisplayName = getCountryDisplayNameFromSessionCountry(getSessionCountry(), strictLocalize);
    var title = countryDisplayName ? // the description is outdated. Faire homepage title tag is being overriden in LoggedOutHome.tsx
    // we don't want to change the description because it will retrigger translation job
    strictLocalize({
        id: "WWuR/T",
        defaultMessage: [
            {
                type: 0,
                value: "Faire "
            },
            {
                type: 1,
                value: "country"
            },
            {
                type: 0,
                value: " - The Online Wholesale Marketplace & Store"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        country: countryDisplayName
    })) : strictLocalize({
        id: "VG15JJ",
        defaultMessage: [
            {
                type: 0,
                value: "Faire - The Online Wholesale Marketplace & Store"
            }
        ]
    });
    return isLoggedInRetailer() ? strictLocalize({
        id: "7Iu/jU",
        defaultMessage: [
            {
                type: 0,
                value: "Faire \u2014 Unique wholesale merchandise for your store."
            }
        ]
    }) : title;
};
export var setDefaultTitleTag = function(strictLocalize) {
    var defaultTitleTag = getDocumentOrThrow().head.querySelector("title");
    var faireHelmetTitleTagFound = getDocumentOrThrow().head.querySelector("title[data-faire-helmet]");
    if (faireHelmetTitleTagFound) {
        return;
    }
    if (!defaultTitleTag) {
        defaultTitleTag = getDocumentOrThrow().createElement("title");
        getDocumentOrThrow().head.appendChild(defaultTitleTag);
    }
    defaultTitleTag.innerHTML = getDefaultTitle(strictLocalize);
    defaultTitleTag.setAttribute("data-react-helmet", "true");
};
